import '../assets/styles/index.scss';
import '../assets/styles/contact.scss';
import { useEffect, useState } from 'react';

// ── Inline icons ──────────────────────────────────────────────
function MailIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="2" y="4" width="20" height="16" rx="2" />
      <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
    </svg>
  );
}

function PinIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
      <circle cx="12" cy="10" r="3" />
    </svg>
  );
}

function SendIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="m22 2-7 20-4-9-9-4Z" />
      <path d="M22 2 11 13" />
    </svg>
  );
}

function CheckIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M20 6 9 17l-5-5" />
    </svg>
  );
}

const socialLinks = [
  {
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/in/piusiniobong/',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
        <rect x="2" y="9" width="4" height="12" />
        <circle cx="4" cy="4" r="2" />
      </svg>
    ),
  },
  {
    label: 'GitHub',
    href: 'https://github.com/payose',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M15 22v-4a4.8 4.8 0 0 0-1-3.5c3 0 6-2 6-5.5.08-1.25-.27-2.48-1-3.5.28-1.15.28-2.35 0-3.5 0 0-1 0-3 1.5-2.64-.5-5.36-.5-8 0C6 2 5 2 5 2c-.3 1.15-.3 2.35 0 3.5A5.403 5.403 0 0 0 4 9c0 3.5 3 5.5 6 5.5-.39.49-.68 1.05-.85 1.65-.17.6-.22 1.23-.15 1.85v4" />
        <path d="M9 18c-4.51 2-5-2-7-2" />
      </svg>
    ),
  },
  {
    label: 'Hashnode',
    href: 'https://hashnode.com/@pye',
    icon: (
      <svg width="16" height="16" viewBox="0 0 337 337" fill="currentColor" aria-hidden="true">
        <path fillRule="evenodd" clipRule="evenodd" d="M168.5 0C75.44 0 0 75.44 0 168.5S75.44 337 168.5 337 337 261.56 337 168.5 261.56 0 168.5 0zm-.69 99.5c38.15 0 69.19 31.04 69.19 69.19s-31.04 69.19-69.19 69.19S99.62 206.84 99.62 168.69 130.66 99.5 167.81 99.5z"/>
      </svg>
    ),
  },
];

// ── Contact Info Panel ────────────────────────────────────────
function InfoPanel() {
  return (
    <div className="contact-info-panel animate-on-load">
      {/* Available badge */}
      <div className="avail-badge">
        <span className="avail-dot" />
        Available for freelance work
      </div>

      <h2 className="info-panel__heading">
        Let's build<br />something great.
      </h2>
      <p className="info-panel__sub">
        Whether you have a project in mind, want to collaborate, or just want to say
        hello — my inbox is always open.
      </p>

      {/* Contact details */}
      <div className="info-contacts">
        <a href="mailto:umoumaniniobong@gmail.com" className="info-contact-row">
          <span className="info-contact-icon"><MailIcon /></span>
          <span className="info-contact-text">umoumaniniobong@gmail.com</span>
        </a>
        <div className="info-contact-row">
          <span className="info-contact-icon"><PinIcon /></span>
          <span className="info-contact-text">Lagos, Nigeria</span>
        </div>
      </div>

      {/* Divider */}
      <div className="info-divider" />

      {/* Socials */}
      <p className="info-socials-label">Connect online</p>
      <div className="info-socials">
        {socialLinks.map((s) => (
          <a key={s.label} href={s.href} target="_blank" rel="noreferrer" className="info-social-btn" aria-label={s.label} title={s.label}>
            {s.icon}
          </a>
        ))}
      </div>
    </div>
  );
}

// ── Contact Form ──────────────────────────────────────────────
function ContactForm() {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState('idle'); // 'idle' | 'sending' | 'success' | 'error'

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: '' }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate
    const newErrors = {};
    if (!form.name.trim()) newErrors.name = 'Your name is required.';
    if (!form.email.trim()) {
      newErrors.email = 'Email address is required.';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
      newErrors.email = 'Please enter a valid email.';
    }
    if (!form.message.trim()) newErrors.message = 'A message is required.';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    // Submit
    setStatus('sending');
    setErrors({});

    fetch('https://formspree.io/f/mbdabokn', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(form),
    })
      .then((response) => {
        if (response.ok) {
          setStatus('success');
        } else {
          setStatus('error');
          setErrors({ submit: 'Failed to send message. Please try again.' });
        }
      })
      .catch(() => {
        setStatus('error');
        setErrors({ submit: 'Failed to send message. Please try again.' });
      });
  };

  const resetForm = () => {
    setStatus('idle');
    setForm({ name: '', email: '', subject: '', message: '' });
    setErrors({});
  };

  if (status === 'success') {
    return (
      <div className="contact-form-card sent-state">
        <div className="sent-icon"><CheckIcon /></div>
        <h3 className="sent-title">Message received!</h3>
        <p className="sent-sub">Thanks for reaching out. I'll get back to you very soon.</p>
        {/* <button className="btn-send mt-4" onClick={resetForm}>
          Send another
        </button> */}
      </div>
    );
  }

  return (
    <form className="contact-form-card animate-on-load" onSubmit={handleSubmit} noValidate>
      <div className="row g-4">
        {/* Name */}
        <div className="col-sm-6">
          <label className="cf-label" htmlFor="cf-name">Full name <span className="cf-req">*</span></label>
          <input
            id="cf-name"
            name="name"
            type="text"
            className={`cf-input${errors.name ? ' is-invalid' : ''}`}
            placeholder="Iniobong Pius"
            value={form.name}
            onChange={handleChange}
          />
          {errors.name && <span className="cf-error">{errors.name}</span>}
        </div>

        {/* Email */}
        <div className="col-sm-6">
          <label className="cf-label" htmlFor="cf-email">Email address <span className="cf-req">*</span></label>
          <input
            id="cf-email"
            name="email"
            type="email"
            className={`cf-input${errors.email ? ' is-invalid' : ''}`}
            placeholder="you@example.com"
            value={form.email}
            onChange={handleChange}
          />
          {errors.email && <span className="cf-error">{errors.email}</span>}
        </div>

        {/* Subject */}
        <div className="col-12">
          <label className="cf-label" htmlFor="cf-subject">Subject</label>
          <input
            id="cf-subject"
            name="subject"
            type="text"
            className="cf-input"
            placeholder="Project collaboration, freelance inquiry…"
            value={form.subject}
            onChange={handleChange}
          />
        </div>

        {/* Message */}
        <div className="col-12">
          <label className="cf-label" htmlFor="cf-message">Message <span className="cf-req">*</span></label>
          <textarea
            id="cf-message"
            name="message"
            rows={5}
            className={`cf-input cf-textarea${errors.message ? ' is-invalid' : ''}`}
            placeholder="Tell me about your project, timeline, budget…"
            value={form.message}
            onChange={handleChange}
          />
          {errors.message && <span className="cf-error">{errors.message}</span>}
        </div>

        {/* Submit */}
        <div className="col-12">
          <button type="submit" className="btn-send" disabled={status === 'sending'}>
            {status === 'sending' ? (
              <>
                <span className="btn-spinner" />
                Sending…
              </>
            ) : (
              <>
                <SendIcon />
                Send Message
              </>
            )}
          </button>
          {errors.submit && <span className="cf-error mt-2 d-block">{errors.submit}</span>}
        </div>
      </div>
    </form>
  );
}

// ── Page ──────────────────────────────────────────────────────
function Contact() {
  useEffect(() => {
    const elements = document.querySelectorAll('.animate-on-load');
    elements.forEach((el, i) => setTimeout(() => el.classList.add('animate-in'), i * 120));
  }, []);

  return (
    <div className="contact-page">
      {/* ─── Page Header ──────────────────────────────────── */}
      <section className="contact-hero">
        <div className="wd-8 w-100">
          <p className="section-label animate-on-load">Get In Touch</p>
          <h1 className="contact-hero__title animate-on-load">
            Say Hello<span className="contact-hero__dot">.</span>
          </h1>
          <p className="contact-hero__sub animate-on-load">
            I'm always open to new opportunities, collaborations, and conversations.
          </p>
        </div>
      </section>

      {/* ─── Main Content ─────────────────────────────────── */}
      <section className="contact-body">
        <div className="wd-8 w-100">
          <div className="row g-5 align-items-start">
            {/* Left — Info */}
            <div className="col-lg-5">
              <InfoPanel />
            </div>

            {/* Right — Form */}
            <div className="col-lg-7">
              <ContactForm />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;
